import ICONS from "./icons";
import {
  githubLink,
  instagramLink,
  linkedinLink,
  twitterLink,
  youtubeLink,
} from "./links";

const socialLinkData = [
  {
    title: "LinkedIn",
    key: "linkedin",
    icon: ICONS.LINKEDIN,
    link: linkedinLink,
  },
  {
    title: "GitHub",
    key: "github",
    icon: ICONS.GITHUB,
    link: githubLink,
  },
  {
    title: "Twitter",
    key: "twitter",
    icon: ICONS.TWITTER,
    link: twitterLink,
  },
  {
    title: "YouTube",
    key: "youtube",
    icon: ICONS.YOUTUBE,
    link: youtubeLink,
  },
  {
    title: "Instagram",
    key: "instagram",
    icon: ICONS.INSTAGRAM,
    link: instagramLink,
  },
];

export default socialLinkData;
